import { JsonProperty } from '../shared/decorators/json-property';

export class OptionPreviewModel {
  @JsonProperty('user_id')
  id: number;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('middle_name')
  middleName: string;
  @JsonProperty('last_name')
  lastName: string;
  @JsonProperty('first_name_jp')
  firstNameJP: string;
  @JsonProperty('last_name_jp')
  lastNameJP: string;
  email: string;

  constructor() {
    this.id = undefined;
    this.firstName = undefined;
    this.middleName = undefined;
    this.lastName = undefined;
    this.email = undefined;
    this.firstNameJP = undefined;
    this.lastNameJP = undefined;
  }

  getUserName(): string {
    return `${this.firstName || ''} ${this.middleName || ''} ${this.lastName || ''}`;
  }

  getUserNameJP(): string {
    return `${this.firstNameJP || ''} ${this.lastNameJP || ''}`;
  }
}

